<template>
  <v-navigation-drawer
    style="z-index: 99999;"
    v-if="editObject"
    id="core-navigation-draweder"
     v-bind="$attrs"
    right
    fixed
    permanent
    app
  >
    <v-divider class="mb-1"/>

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico"
            max-height="30"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="display-1"
            v-text="'Настройка'"
          />
        </v-list-item-content>


      </v-list-item>

      <v-divider class="mb-2"/>
      <v-list-item>
        <div class="text-center">

          <v-btn class="mx-2"  dark small color="teal" @click="bringToFront()">
            <v-icon dark>mdi-arrow-up-bold</v-icon>
          </v-btn>
          <v-btn class="mx-2"  dark small color="teal" @click="sendBackwards()">
            <v-icon dark>mdi-arrow-down-bold</v-icon>
          </v-btn>
        </div>
      </v-list-item>
      <v-list-item v-if="isText">
        <v-list-item-content class="display-1" >
          <v-text-field type="text" v-model="text" label="Текст" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          Передвиженине
          <v-checkbox
            v-model="selectable"
            hide-details
          ></v-checkbox>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="display-1">
          <v-text-field type="number" v-model="top" label="Отступ сверху" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="display-1">
          <v-text-field type="number" v-model="left" label="Отступ слева" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="display-1">
          <v-text-field type="number" v-model="angle" label="Угол" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>


      <v-list-item v-if="!isEllipse">
        <v-list-item-content class="display-1" v>
          <v-text-field type="number" v-model="width" label="Ширина" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="isEllipse">
        <v-list-item-content class="display-1">
          <v-text-field type="number" v-model="rx" label="Радиус 1" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>


      <v-list-item v-if="isEllipse">
        <v-list-item-content class="display-1" v>
          <v-text-field type="number" v-model="ry" label="Радиус 2" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="!isEllipse">
        <v-list-item-content class="display-1">
          <v-text-field type="number" v-model="height" label="Высота" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="display-1">
          <v-text-field type="text" v-model="color" label="Цвет заливки" hide-details="auto"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="display-1">
          <v-color-picker v-model="generalColor" :value="color" hide-inputs></v-color-picker>
        </v-list-item-content>
      </v-list-item>

    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn color="error" dark large block @click="deleteTable">Удалить</v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  export default {
    props: {},
    components: {},
    mounted() {
      bus.$on('showTableEditor', () => this.editObject = false);
    },
    created() {
      bus.$on('editObject', (payload) => {
        let object = payload.object.target;
        this.typeObject = object.get('type');
        this.object = payload.object.target;
        this.canvas = payload.canvas;
        this.width = parseInt(object.width * object.scaleX);
        this.height = parseInt(object.height * object.scaleY);
        this.radius = parseInt(object.radius * object.scaleX);
        this.text = object.text;
        this.angle = parseInt(object.angle);
        this.color = object.fill;
        this.top = parseInt(object.top);
        this.left = parseInt(object.left);
        this.rx = parseInt(object.rx*object.scaleX);
        this.ry = parseInt(object.ry*object.scaleY);
        this.fontSize = parseInt(object.fontSize* object.scaleX);
        this.selectable = object.selectable;
      })
        .$on('showObjectEditor', () => {
          bus.$emit('tableUnselected');
          this.editObject = true
        })
        .$on('tableUnselected', () => {
          this.editObject = false
        });
    },
    data() {
      return {
        rx : null,
        ry : null,
        typeObject : null,
        radius : 10,
        fontSize: 14,
        object: null,
        canvas: null,
        editObject: false,
        color: '#dddddd',
        text: '',
        width: 10,
        height: 10,
        top: 0,
        left : 0,
        angle: 0,
        editor: true,
        generalColor: null,
        selectable : false,
      }
    },
    computed: {
      isEllipse(){
        return this.typeObject == 'ellipse';
      },
      isText(){
        return this.typeObject == 'text';
      }
    },
    watch: {
      generalColor() {
        if(this.generalColor.hex === '#FF0000'){
          return false;
        }
        this.color = this.generalColor.hexa
      },
      ry(){
        this.fillObject()
      },
      rx(){
        this.fillObject()
      },
      left() {
        this.fillObject()
      },
      top() {
        this.fillObject()
      },
      radius() {
        this.fillObject()
      },
      width() {
        this.fillObject()
      },
      text() {
        this.fillObject()
      },
      color() {
        this.fillObject()
      },
      height() {
        this.fillObject()
      },
      angle() {
        this.fillObject()
      },
      selectable(){
        this.fillObject()
      }
    },
    methods: {
      bringToFront(){
        this.canvas.bringToFront(this.object);
        this.canvas.renderAll();
      },
      sendBackwards(){
        this.canvas.sendBackwards(this.object);
        this.canvas.renderAll();

        this.canvas.getObjects().forEach((o) => {
          if (o.customAttribute) {
            this.canvas.sendToBack(o);
          }
        });

      },
      fillText(){
        this.object.set({
          top : parseFloat(this.top),
          left : parseFloat(this.left),
          fontSize: this.fontSize,
          fill: this.color,
          text: this.text,
          width: parseInt(this.width),
          height: parseInt(this.height),
          angle: parseFloat(this.angle),
          originX: 'center',
          originY: 'center',
          dirty: true,
          scaleX : 1,
          scaleY : 1,
          selectable : this.selectable
        });
      },
      fillCircle(){
        this.object.set({
          top : parseFloat(this.top),
          left : parseFloat(this.left),
          radius : this.radius,
          fill: this.color,
          width: parseInt(this.width),
          height: parseInt(this.height),
          angle: parseFloat(this.angle),
          originX: 'center',
          originY: 'center',
          dirty: true,
          scaleX : 1,
          scaleY : 1,
          selectable : this.selectable
        });
      },
      fillRect() {
        this.object.set({
          top: parseFloat(this.top),
          left: parseFloat(this.left),
          radius: this.radius,
          fontSize: this.fontSize,
          fill: this.color,
          text: this.text,
          width: parseInt(this.width),
          height: parseInt(this.height),
          angle: parseFloat(this.angle),
          originX: 'center',
          originY: 'center',
          dirty: true,
          scaleX: 1,
          scaleY: 1,
          selectable: this.selectable
        });
      },
      fillEllipse(){
        this.object.set({
          rx: parseFloat(this.rx),
          ry : parseFloat(this.ry),
          top : parseFloat(this.top),
          left : parseFloat(this.left),
          fill: this.color,
          text: this.text,
          angle: parseFloat(this.angle),
          originX: 'center',
          originY: 'center',
          dirty: true,
          scaleX : 1,
          scaleY : 1,
          selectable : this.selectable
        });
      },
      fillObject() {

          if(!this.selectable){
            this.object.on('mouseup', (o) => {
              bus.$emit('clickByUnselectableObject', o)
            })
          }

        let objectTypes = this.typeObject.charAt(0).toUpperCase() + this.typeObject.slice(1)
        objectTypes = 'fill'+objectTypes
        this[objectTypes]()
        this.object.setCoords()
        this.canvas.requestRenderAll();
      },
      deleteTable() {
        bus.$emit('deleteTable');
      }
    }
  }
</script>
